import "bootstrap";
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAnalytics from "vue-analytics";
import localeEs from "element-ui/lib/locale/lang/es";
import localePt from "element-ui/lib/locale/lang/pt";
import localeEn from "element-ui/lib/locale/lang/en";

// Webpack hands over the whole CommonJS module ({ __esModule, default }); Element needs the inner object.
const unwrapLocale = (mod) => mod.default || mod;
const elementLocaleMap = { es: localeEs, pt: localePt, en: localeEn };
const locale = unwrapLocale(elementLocaleMap[document.documentElement.lang] || localeEs);
import i18n from "./I18n/I18n";
import Usabilla from "./Libraries/Usabilla";
import ThreatMetrix from "./Libraries/ThreatMetrix";
import SearchForm from "./Components/SearchForm.vue";
import ZendeskSearchForm from "./Components/ZendeskSearchForm.vue";
import Status from "./Components/Status.vue";
import OlaForm from "./Components/OlaForm.vue";
import BackendForm from "./Components/BackendForm.vue";
import CallcenterForm from "./Components/CallcenterForm.vue";
import MobileNav from "./Components/MobileNav.vue";
import MonitorView from "./Components/MonitorView.vue";
import FunnelView from "./Components/FunnelView.vue";
import UsersConfigView from "./Components/UsersConfigView.vue";

Usabilla.load();
ThreatMetrix.profile();

Vue.use(VueAnalytics, {
  id: "UA-137013418-1"
});

// Fallback cuando GA no carga (dominios bloqueados en devl)
if (!Vue.prototype.$ga) {
  Vue.prototype.$ga = { event: () => {} };
}

Vue.use(ElementUI, { locale });

export default new Vue({
  el: "#app",
  components: {
    SearchForm,
    ZendeskSearchForm,
    Status,
    OlaForm,
    BackendForm,
    CallcenterForm,
    MobileNav,
    MonitorView,
    FunnelView,
    UsersConfigView
  },
  i18n
});
